import React, { useEffect, useState } from 'react'

import Select from 'react-select'
import CreateDtcMappingsCheckbox from './ConnectorMapping/ConnectorPinsSection/CreateDtcMappingsCheckbox'
import { getRequest } from '../../../services/base'
import { useParams } from 'react-router-dom'

const CloneMappings = ({ payload, setPayload }) => {
  const [dtcsOptions, setDtcsOptions] = useState([])
  let { dtc_id, vehicle } = useParams()

  useEffect(() => {
    getDtcsOptions('')
  }, [])

  const getDtcsOptions = async (search = '') => {
    let res = await getRequest(
      `/api/dtcs/dtcs_options/${dtc_id}/?vehicle_id=${vehicle}&search=${search}`
    )
    setDtcsOptions(res?.data)
  }

  return (
    <>
      <Select
        name="target_dtcs_ids[]"
        classNamePrefix="dtcs-filter"
        isMulti={true}
        options={dtcsOptions}
        placeholder="Select DTCs or Type to search"
        className={`cursor-pointer py-2 pt-8 w-3/4`}
        onChange={(values) => {
          setPayload({ ...payload, target_dtcs: values })
        }}
        value={payload?.target_dtcs}
        isLoading={dtcsOptions?.length < 1}
        onInputChange={(values) => {
          if (values) {
            getDtcsOptions(values)
          }
        }}
        getOptionLabel={(option) => option.label + option.description}
        formatOptionLabel={(option) => (
          <>
            <div className="font-extrabold">{option.label}</div>
            <div>{option.description}</div>
          </>
        )}
      />
      {payload?.target_dtcs?.length > 0 && (
        <>
          <CreateDtcMappingsCheckbox
            title="Clone existing DTC Mappings"
            field="clone_with_existing_mapping"
            checked={payload?.clone_with_existing_mapping}
            onChange={(value) => {
              setPayload({ ...payload, clone_with_existing_mapping: value })
            }}
            isDark={false}
          />
          <CreateDtcMappingsCheckbox
            title="With Circuit Filters"
            field="create_dtc_circuits"
            checked={payload?.create_dtc_circuits}
            onChange={(value) => {
              setPayload({ ...payload, create_dtc_circuits: value })
            }}
            isDark={false}
          />
        </>
      )}
    </>
  )
}

CloneMappings.propTypes = {}

export default CloneMappings
